// extracted by mini-css-extract-plugin
export default {"box":"Box_box__IDuUJ","box--hover":"Box_box--hover__pEQKG"};